export default __webpack_public_path__ + "static/media/info-red.14fdd280.svg";